import dayjs from 'dayjs'
import QuarterOfYear from 'dayjs/plugin/quarterOfYear'

export const getTime = (str = 'today', time = 'end',isdate=false) => {
    let date;
    switch (str) {
        case 'yesterday':
            date = dayjs().subtract(1, 'day');
            date = time === 'start' ? date.startOf('day') : date.endOf('day');
            break;
        case 'tomorrow':
            date = dayjs().add(1, 'day');
            date = time === 'start' ? date.startOf('day') : date.endOf('day');
            break;
        case 'tomonth':
            date = dayjs();
            date = time === 'start' ? date.startOf('month') : date.endOf('month');
            break;
        case 'nextmonth':
            date = dayjs().add(1, 'month');
            date = time === 'start' ? date.startOf('month') : date.endOf('month');
            break;
        case 'lastmonth':
            date = dayjs().subtract(1, 'month').date(1);
            date = time === 'start' ? date.startOf('month') : date.endOf('month');
            break;
        case 'toweek':
            date = dayjs();
            date = time === 'start' ? date.startOf('week') : date.endOf('week');
            date = date.add(1, 'day');
            break;
        case 'nextweek':
            date = dayjs().add(1, 'week');
            date = time === 'start' ? date.startOf('week') : date.endOf('week');
            date = date.add(1, 'day');
            break;
        case 'lastweek':
            date = dayjs().subtract(1, 'week').day(1);
            date = time === 'start' ? date.startOf('week') : date.endOf('week');
            date = date.add(1, 'day');
            break;
        case 'toyear':
            date = dayjs();
            date = time === 'start' ? date.startOf('year') : date.endOf('year');
            break;
        case 'nextyear':
            date = dayjs().add(1, 'year');
            date = time === 'start' ? date.startOf('year') : date.endOf('year');
            break;
        case 'lastyear':
            date = dayjs().subtract(1, 'year').date(1);
            date = time === 'start' ? date.startOf('year') : date.endOf('year');
            break;
        case 'toquarter':
            dayjs.extend(QuarterOfYear)
            date = dayjs();
            date = time === 'start' ? date.startOf('quarter') : date.endOf('quarter');
            break;
        case 'nextquarter':
            dayjs.extend(QuarterOfYear)
            date = dayjs().add(1, 'quarter');
            date = time === 'start' ? date.startOf('quarter') : date.endOf('quarter');
            break;
        case 'lastquarter':
            dayjs.extend(QuarterOfYear)
            date = dayjs().subtract(1, 'quarter');
            date = time === 'start' ? date.startOf('quarter') : date.endOf('quarter');
            break;
        default:
            date = dayjs();
            date = time === 'start' ? date.startOf('day') : date.endOf('day');
    }
    return isdate?date.format('YYYY-MM-DD'):date.format('YYYY-MM-DD HH:mm:ss');
}